module.exports = __webpack_public_path__ + "static/img/ws-img-signup.1e1d551.jpg";